import { v4 as uuid } from 'uuid';
export class MessageService {
    static $inject = ['MessagingHubService', 'MessageParser'];
    constructor(MessagingHubService, MessageParser) {
        this.MessagingHubService = MessagingHubService;
        this.MessageParser = MessageParser;
    }
    async setSchedule(schedule) {
        schedule.message.id = schedule.message.id || uuid();
        const command = {
            id: uuid(),
            to: 'postmaster@scheduler.msging.net',
            method: 'set',
            uri: '/schedules',
            type: 'application/vnd.iris.schedule+json',
            resource: {
                name: schedule.name,
                message: {
                    id: schedule.message.id,
                    to: schedule.message.to,
                    type: schedule.message.type,
                    content: schedule.message.content,
                    metadata: schedule.message.metadata,
                },
                when: schedule.when,
            },
        };
        return await this.MessagingHubService.sendCommand(command);
    }
    async deleteSchedule(schedule) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@scheduler.msging.net',
            method: 'delete',
            uri: `/schedules/${schedule.message.id}`,
        });
    }
    async getSchedules({ skip, take, ascending = false, since = undefined }) {
        let query = `?$skip=${skip}&$take=${take}&$ascending=${ascending}`;
        if (since) {
            query = `${query}&?$since=${since.toISOString()}`;
        }
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@scheduler.msging.net',
            method: 'get',
            uri: `/schedules${query}`,
        });
    }
    async getSchedule({ id }) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@scheduler.msging.net',
            method: 'get',
            uri: `/schedules/${id}`,
        });
    }
    async setDelegation({ target }) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            method: 'set',
            uri: '/delegations',
            type: 'application/vnd.lime.delegation+json',
            resource: {
                target: target,
                envelopeTypes: ['message'],
            },
        });
    }
    async getNotifications(messageId) {
        const result = await this.MessagingHubService.sendCommand({
            id: uuid(),
            method: 'get',
            uri: `/notifications?id=${messageId}&$skip=0&$take=10`,
        });
        return result.items.map((m) => this.MessageParser.addExtendedProperties(m));
    }
    async getMessages(application, { take = 30, skip = 0, contentFilter = undefined }) {
        const uri = contentFilter
            ? `/messages?$take=${take}&$skip=${skip}&contentFilter=${encodeURIComponent(contentFilter)}`
            : `/messages?$take=${take}&$skip=${skip}`;
        const result = await this.MessagingHubService.sendCommand({
            id: uuid(),
            method: 'get',
            uri: uri,
        });
        if (result && result.items) {
            return result.items.map((m) => this.MessageParser.addExtendedProperties(m));
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
MessageService.$inject = ['MessagingHubService', 'MessageParser'];
